import s from '../solution-rate-reviews.scss';
import React from 'react';
import { StarFilled } from '@wix/wix-ui-icons-common';
import { LinearProgressBar, Box, Text } from '@wix/design-system';

interface IRateCharsProps {
  totalCount: number;
  rating1: number;
  rating2: number;
  rating3: number;
  rating4: number;
  rating5: number;
}

export const RateCharts = (props: IRateCharsProps) => {
  const starsWithProgress = [5, 4, 3, 2, 1];
  return (
    <Box direction="vertical">
      {starsWithProgress.map((swp) => (
        <StarsWithProgress
          key={swp}
          starsTofill={swp}
          reviewers={props[`rating${swp}`]}
          barPrecentage={countAsPrecentage(
            props.totalCount,
            props[`rating${swp}`],
          )}
        />
      ))}
    </Box>
  );
};

interface IStarWithProgerssProps {
  starsTofill: number;
  barPrecentage: number;
  reviewers?: number;
}

const StarsWithProgress = ({
  starsTofill = 2,
  barPrecentage = 30,
  reviewers = 20,
}: IStarWithProgerssProps) => {
  return (
    <div>
      <Box className={s.reviewersPerStars} verticalAlign="middle">
        <FiveStars starsToFill={starsTofill} />
        <LinearProgressBar value={barPrecentage || 0} />
        <div className={s.reviewCountPerStar}>
          <Text
            size="tiny"
            weight="bold"
            className={s.reviewersPerStars}
            dataHook={`rating${starsTofill}`}
          >
            {reviewers}
          </Text>
        </div>
      </Box>
    </div>
  );
};
interface IFiveStarProps {
  starsToFill?: number;
  size?: number;
}
export const FiveStars = ({ starsToFill = 0, size = 12 }: IFiveStarProps) => {
  const stars = [1, 2, 3, 4, 5];
  return (
    <Box className={s.chartsFiveStars}>
      {stars.map((star, index) => {
        return star <= starsToFill ? (
          <StarFilled key={index} size={size.toString()} color="#FDB10C" />
        ) : (
          <StarFilled size={size.toString()} key={index} color="#E7EAEB" />
        );
      })}
    </Box>
  );
};

const countAsPrecentage = (totalCount: number, prartiaCount: number) => {
  return (prartiaCount * 100) / totalCount;
};
